// New.js

import React, { useState } from "react";

import {
  BadgeDollarSign,
  Rocket,
  ShieldCheck,
  TrendingUp,
  CircleDollarSign,
  Landmark,
  Phone,
  Globe,
  CheckCircle2,
  ArrowRight,
  X,
  Send,
  CheckCircle2Icon,
  AlertTriangle,
} from "lucide-react";

import "../Styles/new.css";

import logo from "../assets/logo.png";

const New = () => {

  const [showLoanModal, setShowLoanModal] =
  useState(false);

const [sending, setSending] =
  useState(false);

const [sendStatus, setSendStatus] =
  useState("");

const [loanForm, setLoanForm] =
  useState({
    name: "",
    telephone: "",
    email: "",
    address: "",
    category: "",
  });

  return (
    <div className="ready-finance-page">

      {/* HERO */}
      <section className="ready-hero">

        <div className="ready-hero-overlay" />

        <div className="ready-hero-content">

          {/* LEFT */}
          <div className="ready-hero-left">

            <div className="ready-badge">
              NEW SERVICE
            </div>

            <h1 className="ready-heading">
              RCS
              <br />
              <span>READY FINANCE</span>
            </h1>

            <div className="ready-subheading">
              Empowering Entrepreneurs To Succeed
            </div>

            <p className="ready-text">
              Whether you’re expanding your business
              or starting a new venture, we’re here
              to help you grow, thrive and achieve
              your goals.
            </p>

            <div className="ready-feature-row">

              <div className="ready-mini-card">
                <Rocket size={28} />
                <span>
                  Quick Approvals
                </span>
              </div>

              <div className="ready-mini-card">
                <ShieldCheck size={28} />
                <span>
                  Flexible Terms
                </span>
              </div>

              <div className="ready-mini-card">
                <TrendingUp size={28} />
                <span>
                  Competitive Rates
                </span>
              </div>

            </div>
<button
  className="ready-apply-btn"
  onClick={() =>
    setShowLoanModal(true)
  }
>
  Apply Today
  <ArrowRight size={18} />
</button>

          </div>

          {/* RIGHT */}
          <div className="ready-hero-right">

            <div className="ready-logo-card">

              <img
                src={logo}
                alt="RCS Logo"
                className="ready-logo"
              />

            </div>

          </div>

        </div>

      </section>

      {/* LOAN TYPES */}
      <section className="loan-types-section">

        <div className="loan-type-card">

          <div className="loan-card-top green">

            <BadgeDollarSign size={32} />

            <div>
              <h2>
                Small Business Loans
              </h2>

              <p>
                Funds for growth & expansion
              </p>
            </div>

          </div>

          <ul>
            <li>
              <CheckCircle2 size={18} />
              Funds for growth & expansion
            </li>

            <li>
              <CheckCircle2 size={18} />
              Equipment & inventory financing
            </li>

            <li>
              <CheckCircle2 size={18} />
              Working capital solutions
            </li>

            <li>
              <CheckCircle2 size={18} />
              No collateral required
            </li>
          </ul>

        </div>

        <div className="loan-type-card">

          <div className="loan-card-top gold">

            <Rocket size={32} />

            <div>
              <h2>
                Start-Up Loans
              </h2>

              <p>
                Launch your dream business
              </p>
            </div>

          </div>

          <ul>
            <li>
              <CheckCircle2 size={18} />
              Capital to launch your business
            </li>

            <li>
              <CheckCircle2 size={18} />
              New and existing businesses
            </li>

            <li>
              <CheckCircle2 size={18} />
              Streamlined application process
            </li>

            <li>
              <CheckCircle2 size={18} />
              Tailored repayment options
            </li>
          </ul>

        </div>

      </section>

      {/* WHY CHOOSE */}
      <section className="why-ready-section">

        <h2>
          Why Choose RCS Ready Finance?
        </h2>

        <div className="why-grid">

          <div className="why-card">
            <Landmark size={36} />
            <h3>Local Expertise</h3>
          </div>

          <div className="why-card">
            <ShieldCheck size={36} />
            <h3>Flexible Terms</h3>
          </div>

          <div className="why-card">
            <CircleDollarSign size={36} />
            <h3>Affordable Rates</h3>
          </div>

          <div className="why-card">
            <TrendingUp size={36} />
            <h3>Business Growth</h3>
          </div>

        </div>

      </section>

      {/* CTA */}
      <section className="ready-contact-section">

        <div className="ready-contact-card">

          <h2>
            Apply Today & Grow Your Business
          </h2>

          <div className="contact-row">
            <Phone size={20} />
            <span>
              Call / WhatsApp: 662-7987
            </span>
          </div>

          <div className="contact-row">
            <Globe size={20} />
            <span>
              www.rcsgy.com
            </span>
          </div>

        </div>

      </section>


{/* LOAN MODAL */}

{showLoanModal && (

  <div className="loan-modal-overlay">

    <div className="loan-modal">

      <button
        className="loan-modal-close"
        onClick={() =>
          setShowLoanModal(false)
        }
      >
        <X size={22} />
      </button>

      <div className="loan-modal-header">

        <h2>
          Apply For RCS Ready Finance
        </h2>

        <p>
          The following documents are required:
        </p>

      </div>

      <div className="loan-req-grid">

        <div className="loan-req-card">
          Government ID
        </div>

        <div className="loan-req-card">
          TIN Number
        </div>

        <div className="loan-req-card">
          Proof of Income
        </div>

      </div>

      <div className="loan-form-grid">

        <input
          type="text"
          placeholder="Full Name"
          value={loanForm.name}
          onChange={(e) =>
            setLoanForm({
              ...loanForm,
              name: e.target.value,
            })
          }
        />

        <input
          type="text"
          placeholder="Telephone"
          value={loanForm.telephone}
          onChange={(e) =>
            setLoanForm({
              ...loanForm,
              telephone: e.target.value,
            })
          }
        />

        <input
          type="email"
          placeholder="Email (Optional)"
          value={loanForm.email}
          onChange={(e) =>
            setLoanForm({
              ...loanForm,
              email: e.target.value,
            })
          }
        />

        <input
          type="text"
          placeholder="Address"
          value={loanForm.address}
          onChange={(e) =>
            setLoanForm({
              ...loanForm,
              address: e.target.value,
            })
          }
        />

        <select
          value={loanForm.category}
          onChange={(e) =>
            setLoanForm({
              ...loanForm,
              category: e.target.value,
            })
          }
        >
          <option value="">
            Select Category
          </option>

          <option value="Micro">
            Micro
          </option>

          <option value="Small">
            Small
          </option>

          <option value="Medium">
            Medium
          </option>

          <option value="Tailored">
            Tailored
          </option>

        </select>

      </div>

      <button
        className="loan-submit-btn"
        onClick={async () => {

          try {

            setSending(true);

const response =
  await fetch(
    "https://rcsbackend.onrender.com/api/loans/apply",
{
  method: "POST",

  headers: {
    "Content-Type":
      "application/json",
  },

  body: JSON.stringify(
    loanForm
  ),
}
);

            if (!response.ok)
              throw new Error();

            setSending(false);

            setSendStatus(
              "success"
            );

          } catch (err) {

            setSending(false);

            setSendStatus(
              "failure"
            );
          }

          setTimeout(() => {

            setSendStatus("");

            setShowLoanModal(false);

          }, 10000);

        }}
      >

        {sending ? (
          <>
            <Send size={18} />
            Sending...
          </>
        ) : (
          <>
            Submit Application
            <ArrowRight size={18} />
          </>
        )}

      </button>

      {sendStatus && (

        <div
          className={`loan-status-popup ${
            sendStatus
          }`}
        >

          {sendStatus ===
          "success" ? (
            <>
              <CheckCircle2Icon size={70} />

              <h3>
                Application Sent!
              </h3>

              <p>
                Our team will contact
                you shortly.
              </p>
            </>
          ) : (
            <>
              <AlertTriangle size={70} />

              <h3>
                Submission Failed
              </h3>

              <p>
                Please try again later.
              </p>
            </>
          )}

        </div>
      )}

    </div>

  </div>
)}


    </div>
  );
};

export default New;